import { Component, OnInit } from '@angular/core';
import { AuthenService } from '../../../../services/Authen/authen.service';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2'
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit {

  constructor(
    private AuthenService: AuthenService,
    private router: Router,
    private SpinnerService: NgxSpinnerService
  ) { }

  auth_data: any;
  user_data: any;
  username: any;
  password: any;
  fName: any;
  lName: any;
  eMail: any;
  tel: any;
  prefix: any;
  role: any;
  select_khet_data = [];
  warning = false;
  center_data: any;
  select_center_data: any;

  institution_data: any;
  institution_khet_arr1 = [];
  institution_khet_arr2 = [];
  institution_province: any;

  get_khetdata = false;

  ngOnInit(): void {
    this.auth_data = JSON.parse(localStorage.getItem("access_token"));
  }

  create_user() {
    this.AuthenService.AddUsers(this.username, this.password, this.prefix, this.fName, this.lName, this.eMail, this.role, this.tel, this.auth_data['username'], this.auth_data['username']).subscribe(
      response => {
        this.SpinnerService.show();
        if (this.role == 'District_inspector' || this.role == 'Provincial_officials') {
          this.add_khet_province(response.id);
        }
        this.AuthenService.sent_email(this.username, this.password, this.eMail).subscribe();
        this.SpinnerService.hide();
        Swal.fire({
          icon: 'success',
          title: 'สร้างบัญชีใหม่เสร็จสิ้น',
          showConfirmButton: false,
          timer: 1500
        });
        this.router.navigate(['/user-management']);
      }
    );
  }

  verify_data() {
    if (!this.username || !this.password || !this.fName || !this.lName || !this.eMail || !this.tel || !this.prefix || !this.role || (this.role == 'District_inspector' && !this.select_khet_data) || (this.role == 'Provincial_officials' && !this.institution_province) || (this.role == 'Central_agency' && !this.select_center_data)) {
      this.warning = true;
    } else {
      this.warning = false;
      this.create_user();
    }
  }

  add_khet_province(idUser) {
    let body = [];
    if (this.select_khet_data) {
      for (let i = 0; i < this.select_khet_data.length; i++) {
        const data = {
          "idUser": idUser,
          "type": "khet",
          "idSeq": this.select_khet_data[i]
        };
        body.push(data);
      }
    } else if (this.institution_province) {
      const data = {
        "idUser": idUser,
        "type": "province",
        "idSeq": this.institution_data
      };
      body.push(data);
    } else if (this.center_data) {
      const data = {
        "idUser": idUser,
        "type": "center",
        "idSeq": this.select_center_data
      };
      body.push(data);
    }
    this.AuthenService.Add_mapping_user(body, idUser).subscribe(
      response => {
        this.SpinnerService.hide();
      }
    );
  }

  get_username(data) {
    this.username = data;
  }

  get_password(data) {
    this.password = data;
  }

  get_fName(data) {
    this.fName = data;
  }

  get_lName(data) {
    this.lName = data;
  }

  get_eMail(data) {
    this.eMail = data;
  }

  get_tel(data) {
    this.tel = data;
  }

  get_prefix(data) {
    this.prefix = data;
  }

  get_role(data) {
    this.role = data;
    if (data == "Provincial_officials") {
      this.get_province();
      this.select_khet_data = undefined;
      this.center_data = undefined;
    } else if (data == "District_inspector") {
      this.get_khet();
      this.institution_province = undefined;
      this.center_data = undefined;
    } else if (data == "Central_agency") {
      this.get_center();
      this.select_khet_data = undefined;
      this.institution_province = undefined;
    }
  }

  get_center() {
    this.AuthenService.Get_user_center().subscribe(
      response => {
        this.center_data = response;
      }
    );
  }

  get_khet() {
    if (!this.get_khetdata) {
      this.AuthenService.Get_user_khet().subscribe(
        response => {
          let i = 0;
          let j = 0;
          let data = [];
          data = response;
          let data2 = []
          while (i < response.length) {
            data[i]['khetId'] = data[i]['khetId'].trim();
            data2[i] = parseInt(data[i]['khetId']);
            i++;
          }
          //แบ่งฝั่งซ้ายขวาให้ modal เพื่อความสวยงาม และ เรียงข้อมูล
          while (j < 23) {
            const data_id = (element) => element == j + 1;
            const index = data2.findIndex(data_id)
            if (index != -1) {
              if (response[index]['khetId'] < 10) {
                response[index]['khetId'] = response[index]['khetId'] + "  ";
              } else {
                response[index]['khetId'] = response[index]['khetId'] + " ";
              }
              if (j < data.length / 2) {
                this.institution_khet_arr1.push(response[index]);
              } else {
                this.institution_khet_arr2.push(response[index]);
              }
            }
            j++;
          }
          this.get_khetdata = true;
        }
      );
    }
  }

  get_khet_select(value) {
    const found = this.select_khet_data.find(element => element == value);
    if (!found) {
      this.select_khet_data.push(value) //add
    } else {
      const index = this.select_khet_data.indexOf(value)
      this.select_khet_data.splice(index, 1);
    }
  }

  get_province() {
    this.AuthenService.Get_user_Province().subscribe(
      response => {
        this.institution_province = response;
      }
    );
  }

  get_institution(data) {
    this.institution_data = data;
  }

  get_center_data(data) {
    this.select_center_data = data;
  }

  cancle() {
    this.router.navigate(['/user-management']);
  }
}
